module.exports = __webpack_public_path__ + "static/media/success.8da80452.png";